import React, {
    useState
} from "react";

import {
    useLocation,
    useNavigate,
    useParams
} from "react-router-dom";

import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import "./ShowFreeResult.css";


function ShowFreeResult() {

    const navigate =
        useNavigate();


    const {
        paperId
    } = useParams();


    const location =
        useLocation();


    /*
    |--------------------------------------------------------------------------
    | Sidebar
    |--------------------------------------------------------------------------
    */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | User Name
    |--------------------------------------------------------------------------
    */

    const name =
        Cookies.get("username") ||
        "Student";


    /*
    |--------------------------------------------------------------------------
    | Result Data
    |--------------------------------------------------------------------------
    */

    const result =
        location.state?.result ||
        null;


    const paper =
        location.state?.paper ||
        result?.paper ||
        null;


    /*
    |--------------------------------------------------------------------------
    | Debug
    |--------------------------------------------------------------------------
    */

    console.log(
        "SHOW RESULT LOCATION STATE:",
        location.state
    );


    console.log(
        "SHOW RESULT DATA:",
        result
    );


    /*
    |--------------------------------------------------------------------------
    | Result Missing
    |--------------------------------------------------------------------------
    */

    if (
        !result ||
        !result.review
    ) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={name}
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    <div className="dashboard-content py-4 px-3 px-md-4">

                        <div className="show-result-container">

                            <div className="result-empty-box">

                                <div className="result-empty-icon">

                                    <i className="bi bi-file-earmark-x"></i>

                                </div>


                                <h3>
                                    Result Not Found
                                </h3>


                                <p>
                                    Result information is not available.
                                    Please go back to Free MCQ papers.
                                </p>


                                <button
                                    type="button"
                                    className="result-back-btn"
                                    onClick={
                                        handleBackToPapers
                                    }
                                >

                                    <i className="bi bi-arrow-left"></i>

                                    Back to Free MCQs

                                </button>

                            </div>

                        </div>

                    </div>

                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Result Values
    |--------------------------------------------------------------------------
    */

    const review =
        result.review ?? [];


    const totalQuestions =
        result.total_questions ??
        review.length;


    const attempted =
        result.attempted ??
        0;


    const correct =
        result.correct ??
        0;


    const wrong =
        result.wrong ??
        0;


    const unanswered =
        result.unanswered ??
        0;


    const score =
        result.score ??
        0;


    const attemptNumber =
        result.attempt_number ??
        1;


    /*
    |--------------------------------------------------------------------------
    | Percentage
    |--------------------------------------------------------------------------
    */

    const percentage =
        totalQuestions > 0
            ? Math.round(
                (
                    score /
                    totalQuestions
                ) * 100
            )
            : 0;


    /*
    |--------------------------------------------------------------------------
    | Practice Again
    |--------------------------------------------------------------------------
    */

    const handlePracticeAgain = () => {

        navigate(
            `/free-mcq/exam/${paperId}`,
            {
                replace: true
            }
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Back To Papers
    |--------------------------------------------------------------------------
    */

    function handleBackToPapers() {

        navigate(
            "/free-mcq"
        );

    }


    /*
    |--------------------------------------------------------------------------
    | Option Helper
    |--------------------------------------------------------------------------
    */

    const getOptionText = (
        item,
        option
    ) => {

        if (
            option === "A"
        ) {

            return (
                item.option1 ||
                ""
            );

        }


        if (
            option === "B"
        ) {

            return (
                item.option2 ||
                ""
            );

        }


        if (
            option === "C"
        ) {

            return (
                item.option3 ||
                ""
            );

        }


        if (
            option === "D"
        ) {

            return (
                item.option4 ||
                ""
            );

        }


        return "";

    };


    /*
    |--------------------------------------------------------------------------
    | Render
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard">

            <UserSidebar
                sidebarOpen={
                    sidebarOpen
                }
                setSidebarOpen={
                    setSidebarOpen
                }
            />


            <main className="dashboard-main">

                <UserHeader
                    name={name}
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <div className="dashboard-content py-4 px-3 px-md-4">

                    <div className="show-result-container">


                        {/* ======================================================
                            RESULT HEADER
                        ====================================================== */}

                        <div className="result-header-card">

                            <div className="result-header-content">

                                <span className="result-small-title">
                                    FREE MCQ RESULT
                                </span>


                                <h1>

                                    {paper?.paper ||
                                        `Paper #${paperId}`
                                    }

                                </h1>


                                <p>

                                    Attempt{" "}
                                    {attemptNumber}

                                </p>

                            </div>


                            <div className="result-score-circle">

                                <strong>
                                    {percentage}%
                                </strong>


                                <span>
                                    Score
                                </span>

                            </div>

                        </div>


                        {/* ======================================================
                            SUMMARY
                        ====================================================== */}

                        <div className="result-summary-grid">

                            {/* Total Questions */}
                            <div className="result-summary-card summary-total">

                                <div className="result-summary-icon">
                                    <i className="bi bi-list-check"></i>
                                </div>

                                <div>
                                    <span>Total Questions</span>

                                    <strong>
                                        {totalQuestions}
                                    </strong>
                                </div>

                            </div>


                            {/* Correct */}
                            <div className="result-summary-card summary-correct">

                                <div className="result-summary-icon">
                                    <i className="bi bi-check-circle"></i>
                                </div>

                                <div>
                                    <span>Correct</span>

                                    <strong>
                                        {correct}
                                    </strong>
                                </div>

                            </div>


                            {/* Wrong */}
                            <div className="result-summary-card summary-wrong">

                                <div className="result-summary-icon">
                                    <i className="bi bi-x-circle"></i>
                                </div>

                                <div>
                                    <span>Wrong</span>

                                    <strong>
                                        {wrong}
                                    </strong>
                                </div>

                            </div>


                            {/* Unanswered */}
                            <div className="result-summary-card summary-unanswered">

                                <div className="result-summary-icon">
                                    <i className="bi bi-dash-circle"></i>
                                </div>

                                <div>
                                    <span>Unanswered</span>

                                    <strong>
                                        {unanswered}
                                    </strong>
                                </div>

                            </div>


                            {/* Attempted */}
                            <div className="result-summary-card summary-attempted">

                                <div className="result-summary-icon">
                                    <i className="bi bi-pencil-square"></i>
                                </div>

                                <div>
                                    <span>Attempted</span>

                                    <strong>
                                        {attempted}
                                    </strong>
                                </div>

                            </div>


                            {/* Score */}
                            <div className="result-summary-card summary-score">

                                <div className="result-summary-icon">
                                    <i className="bi bi-award"></i>
                                </div>

                                <div>
                                    <span>Score</span>

                                    <strong>
                                        {score}/{totalQuestions}
                                    </strong>
                                </div>

                            </div>

                        </div>


                        {/* ======================================================
                            QUESTION REVIEW
                        ====================================================== */}

                        <div className="question-review-section">

                            <div className="question-review-heading">

                                <div>

                                    <span>
                                        QUESTION REVIEW
                                    </span>


                                    <h2>
                                        Review Your Answers
                                    </h2>

                                </div>


                                <div className="review-count">

                                    {review.length}
                                    {" "}
                                    Questions

                                </div>

                            </div>


                            {review.map(
                                (
                                    item,
                                    index
                                ) => {

                                    const selectedOption =
                                        item.selected_option ||
                                        "0";


                                    const correctOption =
                                        item.correct_option ||
                                        "0";


                                    const selectedText =
                                        getOptionText(
                                            item,
                                            selectedOption
                                        );


                                    const correctText =
                                        getOptionText(
                                            item,
                                            correctOption
                                        );


                                    return (

                                        <div
                                            key={
                                                item.question_id ||
                                                index
                                            }
                                            className={
                                                `result-question-card ${
                                                    item.status || ""
                                                }`
                                            }
                                        >


                                            {/* ==========================================
                                                QUESTION TOP
                                            ========================================== */}

                                            <div className="result-question-top">

                                                <div className="result-question-number">

                                                    Q{" "},{" "}
                                                    {String(index + 1).padStart(2, "0")}

                                                </div>


                                                <div
                                                    className={
                                                        `question-status-badge ${
                                                            item.status || ""
                                                        }`
                                                    }
                                                >

                                                    {item.status ===
                                                        "correct" && (
                                                            <>
                                                                <i className="bi bi-check-circle-fill"></i>

                                                                Correct
                                                            </>
                                                        )
                                                    }


                                                    {item.status ===
                                                        "wrong" && (
                                                            <>
                                                                <i className="bi bi-x-circle-fill"></i>

                                                                Wrong
                                                            </>
                                                        )
                                                    }


                                                    {item.status ===
                                                        "unanswered" && (
                                                            <>
                                                                <i className="bi bi-dash-circle-fill"></i>

                                                                Unanswered
                                                            </>
                                                        )
                                                    }

                                                </div>

                                            </div>


                                            {/* ==========================================
                                                QUESTION
                                            ========================================== */}

                                            <div
                                                className="result-question-text"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        item.question ||
                                                        ""
                                                }}
                                            />


                                            {/* ==========================================
                                                OPTIONS
                                            ========================================== */}

                                            <div className="result-options">

                                                {[
                                                    "A",
                                                    "B",
                                                    "C",
                                                    "D"
                                                ].map(
                                                    option => {

                                                        const optionText =
                                                            getOptionText(
                                                                item,
                                                                option
                                                            );


                                                        const isSelected =
                                                            selectedOption ===
                                                            option;


                                                        const isCorrect =
                                                            correctOption ===
                                                            option;


                                                        let optionClass =
                                                            "result-option";


                                                        if (
                                                            isCorrect
                                                        ) {

                                                            optionClass +=
                                                                " result-option-correct";

                                                        }


                                                        if (
                                                            isSelected &&
                                                            !isCorrect
                                                        ) {

                                                            optionClass +=
                                                                " result-option-wrong";

                                                        }


                                                        if (
                                                            isSelected &&
                                                            isCorrect
                                                        ) {

                                                            optionClass +=
                                                                " result-option-selected-correct";

                                                        }


                                                        return (

                                                            <div
                                                                key={
                                                                    option
                                                                }
                                                                className={
                                                                    optionClass
                                                                }
                                                            >

                                                                <div className="result-option-letter">

                                                                    {option}

                                                                </div>


                                                                <div
                                                                    className="result-option-text"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html:
                                                                            optionText
                                                                    }}
                                                                />


                                                                <div className="result-option-status">

                                                                    {isCorrect && (

                                                                        <span className="correct-label">

                                                                            <i className="bi bi-check-circle-fill"></i>

                                                                            Correct Answer

                                                                        </span>

                                                                    )}


                                                                    {isSelected &&
                                                                        !isCorrect && (

                                                                            <span className="wrong-label">

                                                                                <i className="bi bi-x-circle-fill"></i>

                                                                                Your Answer

                                                                            </span>

                                                                        )
                                                                    }

                                                                </div>

                                                            </div>

                                                        );

                                                    }
                                                )}

                                            </div>


                                            {/* ==========================================
                                                ANSWER INFORMATION
                                            ========================================== */}

                                            <div className="answer-information">


                                                <div className="answer-info-item">

                                                    <span>
                                                        Your Answer
                                                    </span>


                                                    <strong
                                                        className={
                                                            selectedOption ===
                                                            "0"

                                                                ? "unanswered-text"

                                                                : item.is_correct

                                                                    ? "correct-text"

                                                                    : "wrong-text"
                                                        }
                                                    >

                                                        {selectedOption ===
                                                            "0"

                                                            ? "Not Answered"

                                                            : `${selectedOption} - ${selectedText}`
                                                        }

                                                    </strong>

                                                </div>


                                                <div className="answer-info-item">

                                                    <span>
                                                        Correct Answer
                                                    </span>


                                                    <strong className="correct-text">

                                                        {correctOption}
                                                        {" - "}
                                                        {correctText}

                                                    </strong>

                                                </div>

                                            </div>


                                            {/* ==========================================
                                                EXPLANATION
                                            ========================================== */}

                                            <div className="result-explanation">

                                                <div className="result-explanation-title">

                                                    <i className="bi bi-lightbulb-fill"></i>

                                                    Explanation

                                                </div>


                                                <div
                                                    className="result-explanation-content"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            item.explanation ||
                                                            "<p>Explanation not available.</p>"
                                                    }}
                                                />

                                            </div>

                                        </div>

                                    );

                                }
                            )}

                        </div>


                        {/* ======================================================
                            FOOTER BUTTONS
                        ====================================================== */}

                        <div className="result-action-buttons">


                            {attemptNumber < 2 && (

                                <button
                                    type="button"
                                    className="result-practice-btn"
                                    onClick={
                                        handlePracticeAgain
                                    }
                                >

                                    <i className="bi bi-arrow-repeat"></i>

                                    Practice Again

                                </button>

                            )}


                            <button
                                type="button"
                                className="result-back-btn"
                                onClick={
                                    handleBackToPapers
                                }
                            >

                                <i className="bi bi-arrow-left"></i>

                                Back to Free MCQs

                            </button>

                        </div>

                    </div>

                </div>

            </main>

        </div>

    );

}


export default ShowFreeResult;